import React from 'react';

import { useAppDispatch, useAppSelector } from 'segments/hooks';
import { dateToKey } from 'segments/utils/helpers/dateToKey';

import { changeCoachesBookingActiveModal, selectCoachesBookingActiveModal, SelectedBookingCoach } from 'features/coachesBooking';

import { BookedCoachDetailModal } from './components/BookedCoachDetailModal';
import BookingCoachModal from './components/BookingCoachModal';
type Props = {
  selectedCoachBooking?: SelectedBookingCoach;
  selectedBookingId?: number;
};

export const CoachesBookingModals = ({ selectedCoachBooking, selectedBookingId }: Props) => {
  const activeModal = useAppSelector(selectCoachesBookingActiveModal);
  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(changeCoachesBookingActiveModal(null));

  return (
    <>
      <BookingCoachModal
        key={`bookingCoach${selectedCoachBooking?.coachId}${dateToKey(selectedCoachBooking?.startTime)}`}
        isModalOpen={activeModal === 'booking-coach-modal' && selectedCoachBooking?.coachId !== undefined}
        handleCancel={closeModal}
        initData={selectedCoachBooking}
      />
      <BookedCoachDetailModal
        key={`bookedCoachDetail${selectedBookingId}`}
        isModalOpen={activeModal === 'booked-coach-detail-modal' && selectedBookingId !== undefined}
        handleCancel={closeModal}
        bookingId={selectedBookingId}
      />
    </>
  );
};
